import Axios from "@/helpers/axios";

export default {
    SAVEPROFILE(context, data) {
        return Axios.post('/user/profile-save', data);
    },
    SAVEPASS(context,data){
        return Axios.post('/user/change-pass',data);
    },
    CHANGEEMAIL(context,data){
        return Axios.post('/user/change-email',data);
    },
    PROFILE(){
        return Axios.get('/user/profile');
    },
    UNLINK_FACEBOOK() {
        return Axios.get('/user/fb-unlink');
    }
}